let initialized = false
let questionActive = false
let questionStartedAt = 0
let firstInteractionAt = null
let pointerMoves = 0
let pointerDistance = 0
let clicks = 0
let touches = 0
let hiddenCount = 0
let focusChanges = 0
let lastX = null
let lastY = null

function markFirstInteraction() {
  if (firstInteractionAt === null) {
    firstInteractionAt = performance.now()
  }
}

function onPointerMove(event) {
  if (!questionActive) return
  markFirstInteraction()
  pointerMoves++
  if (lastX !== null && lastY !== null) {
    pointerDistance += Math.hypot(event.clientX - lastX, event.clientY - lastY)
  }
  lastX = event.clientX
  lastY = event.clientY
}

function onClick() {
  if (!questionActive) return
  markFirstInteraction()
  clicks++
}

function onTouchStart() {
  if (!questionActive) return
  markFirstInteraction()
  touches++
}

function onVisibilityChange() {
  if (!questionActive) return
  if (document.visibilityState === 'hidden') {
    hiddenCount++
  }
}

function onFocusChange() {
  if (!questionActive) return
  focusChanges++
}

export function initTelemetry() {
  if (initialized) return
  try {
    const capture = { capture: true, passive: true }
    window.addEventListener('pointermove', onPointerMove, capture)
    window.addEventListener('click', onClick, capture)
    window.addEventListener('touchstart', onTouchStart, capture)
    document.addEventListener('visibilitychange', onVisibilityChange)
    window.addEventListener('blur', onFocusChange)
    window.addEventListener('focus', onFocusChange)
    initialized = true
  } catch (e) {
    initialized = initialized || false
  }
}

export function beginQuestion() {
  questionActive = true
  questionStartedAt = performance.now()
  firstInteractionAt = null
  pointerMoves = 0
  pointerDistance = 0
  clicks = 0
  touches = 0
  hiddenCount = 0
  focusChanges = 0
  lastX = null
  lastY = null
}

function snapshot() {
  try {
    if (!initialized || !questionActive) return null
    const now = performance.now()
    const summary = {
      v: 1,
      ttaMs: Math.round(now - questionStartedAt),
      ttfiMs: firstInteractionAt === null ? null : Math.round(firstInteractionAt - questionStartedAt),
      pm: pointerMoves,
      dist: Math.round(pointerDistance),
      clk: clicks,
      tch: touches,
      hid: hiddenCount,
      foc: focusChanges,
      vw: window.innerWidth,
      vh: window.innerHeight,
      dpr: window.devicePixelRatio || 1,
      tz: new Date().getTimezoneOffset(),
      lang: navigator.language || '',
      plat: (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || '',
      touch: (navigator.maxTouchPoints || 0) > 0,
      hc: navigator.hardwareConcurrency || 0,
      app: 'rugbyZone@web',
    }
    questionActive = false
    return summary
  } catch (e) {
    return null
  }
}

function toBase64Utf8(value) {
  const bytes = new TextEncoder().encode(value)
  let binary = ''
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte)
  })
  return btoa(binary)
}

export function telemetryHeader() {
  try {
    const summary = snapshot()
    if (summary) {
      return { 'X-Client-Telemetry': toBase64Utf8(JSON.stringify(summary)) }
    }
  } catch (e) {
    return {}
  }
  return {}
}
